import React, { Component } from 'react';
import { Layout } from 'antd';
import { defineMessages ,   injectIntl } from 'react-intl';
import GuideNav from '../../components/navigation/GuideNav';
import GuideCaution from '../../components/GuideCaution';
import GuideBoxUI from '../../components/GuideBoxUI';
import FrequentMistakes from '../../components/FrequentMistakes';
import SizeAndMargins from '../../components/SizeAndMargins';
import Headline from '../../components/Headline';

const { Content } = Layout;
const messages=defineMessages({
  format:{
    id:'Guide.formatTable.format',
    defaultMessage:'Format'
  },
  background:{
    id:'Guide.formatTable.background',
    defaultMessage:'Background'
  },
  backgroundData:{
    id:'Guide.formatTable.background.data',
    defaultMessage:'Transparent'
  },
  resolution:{
    id:'Guide.formatTable.resolution',
    defaultMessage:'Resolution'
  },
  colorMode:{
    id:'Guide.formatTable.colorMode',
    defaultMessage:'Color Mode'
  },
  colorModeData:{
    id:'Guide.formatTable.colorMode.data',
    defaultMessage:'RGB (Recommend)'
  },
  formatData:{
    id:'Guide.formatTable.format.data',
    defaultMessage:'GIF (Recommend) / APNG'
  },
  frame:{
    id:'Guide.animatedSticker.frameTable.frame',
    defaultMessage:'Frame'
  },
  frameData:{
    id:'Guide.animatedSticker.frameTable.frame.data',
    defaultMessage:'Not more than 15 fps'
  },
  duration:{
    id:'Guide.animatedSticker.frameTable.duration',
    defaultMessage:'Duration'
  },
  durationData:{
    id:'Guide.animatedSticker.frameTable.duration.data',
    defaultMessage:'Less than 2 seconds'
  },
  saveCaution : {
    dither : {
      id:'Guide.animatedSticker.saveCautionTable.dither',
      defaultMessage:'Method 1'
    },
    matteWhite : {
      id:'Guide.animatedSticker.saveCautionTable.matteWhite',
      defaultMessage:'Method 2'
    },
    noMatte : {
      id:'Guide.animatedSticker.saveCautionTable.noMatte',
      defaultMessage:'X'
    }
  },
  saveCautionData : {
    dither : {
      id:'Guide.animatedSticker.saveCautionTable.dither.data',
      defaultMessage:'Matte > None\n“Diffusion Transparency Dither”'
    },
    matteWhite : {
      id:'Guide.animatedSticker.saveCautionTable.matteWhite.data',
      defaultMessage:'Matte > White\n(White Mandatory)'
    },
    noMatte : {
      id:'Guide.animatedSticker.saveCautionTable.noMatte.data',
      defaultMessage:'Matte > None\n“No Transparency Dither”'
    }
  }
});

const newlineUI = text => (
  <div style={{padding: '12px 0px'}}>
    {
      text.split('\n').map(line => <p style={{margin:0}} key={line}>{line}</p>)
    }
  </div>
)


class AnimatedSticker extends Component{

  render(){
    const {formatMessage}=this.props.intl;
    const formatColumn = [{
        title: formatMessage(messages.format),
        width: 183,
        dataIndex:'format'
      },{
        title: formatMessage(messages.background),
        width: 183,
        dataIndex:'background'
      },{
        title: formatMessage(messages.resolution),
        width: 183,
        dataIndex:'resolution'
      },{
        title: formatMessage(messages.colorMode),
        width: 183,
        dataIndex:'colorMode'
    }];
    const formatData =  [{
      key: '1',
      format: formatMessage(messages.formatData),
      background: formatMessage(messages.backgroundData),
      resolution: '72 dpi',
      colorMode:formatMessage(messages.colorModeData)
    }];
    const frameColumn = [{
        title: formatMessage(messages.frame),
        dataIndex:'frame',
        width:320
      },{
        title: formatMessage(messages.duration),
        dataIndex:'duration',
        width:320
      }];
    const frameData =  [{
      key: '1',
      frame: formatMessage(messages.frameData),
      duration: formatMessage(messages.durationData)
    }];
    const saveCautionColumn = [{
      title: formatMessage(messages.saveCaution.dither),
      width:227,
      dataIndex : 'dither'
    },{
      title : formatMessage(messages.saveCaution.matteWhite),
      width:227,
      dataIndex : 'matteWhite'
    },{
      title : formatMessage(messages.saveCaution.noMatte),
      width:227,
      dataIndex : 'noMatte'
    }]
    const saveCautionData =[{
      key : 1,
      dither: newlineUI(formatMessage(messages.saveCautionData.dither)),
      matteWhite: newlineUI(formatMessage(messages.saveCautionData.matteWhite)),
      noMatte: newlineUI(formatMessage(messages.saveCautionData.noMatte)),
    },{
      key : 2,
      dither: <img src={require('../../img/guide/save_caution_dither.svg').default} width={227} alt="dither"/>,
      matteWhite: <img src={require('../../img/guide/save_caution_matte_white.svg').default} width={227} alt="matte-write"/>,
      noMatte: <img src={require('../../img/guide/save_caution_no_matte.svg').default} width={227} alt="no-matte"/>,
    }]

    return(
      <Layout style={{background: '#fff' }}>
        <GuideNav selectedKey={"animatedSticker"} openKey={"movingStatus"} location={this.props.location}/>
        <Content style={{margin:20}}>
          <Headline id="Guide.animatedSticker.headline" defaultMessage="Animated Sticker"
            styles={{margin: '22px 0px 0px 0px', fontFamily: 'NotoSans', fontSize: '34px', lineHeight: '36px', letterSpacing: 0}}
          />
          <div className="guide-wrapper">
          <GuideCaution/>
          <GuideBoxUI
            imgIcon={require('../../img/guide/format_icon_gif.svg').default}
            title={{
              id: 'Guide.format',
              defaultMessage :'Format'
            }}
            table={{
              column : formatColumn,
              data: formatData,
              className : 'format-table'
            }}
            description={{
              id :'Guide.animatedSticker.format.description',
              defaultMessage:'If the pack type selected is Animated Sticker, no file format other than GIF can be uploaded.'
            }}
          />
          <GuideBoxUI
            imgIcon={require('../../img/guide/format_icon_frame.svg').default}
            title={{
              id: 'Guide.animatedSticker.frame',
              defaultMessage :'Frame'
            }}
            table={{
              column : frameColumn,
              data: frameData,
              className: 'frame-table'
            }}
            description={{
              id :'Guide.animatedSticker.frame.description',
              defaultMessage:'- Make the file 15 fps or less.<br/>- Set loop repeat to keep GIF playing.'
            }}
            />
          <SizeAndMargins/>
          <GuideBoxUI
            imgIcon={require('../../img/guide/format_icon_save.svg').default}
            title={{
              id: 'Guide.animatedSticker.saveCaution',
              defaultMessage :'Settings when saving GIF stickers'
            }}
            table={{
              column : saveCautionColumn,
              data: saveCautionData,
              className : 'save-caution-gif-example-img'
            }}
            description={{
              id :'Guide.animatedSticker.saveCaution.description',
              defaultMessage:'A white border may or may not appear around the sticker depending on the matte setting.<br/>When you’re selecting your matte setting in the GIF export settings, select between method 1・2.'
            }}
          />
          <FrequentMistakes/>
          </div>
        </Content>
      </Layout>
    )
  }
}
  
AnimatedSticker=injectIntl(AnimatedSticker);
export default AnimatedSticker;
